import { Observable, OperatorFunction } from 'rxjs';

export const createSelector = <T>(
  source: Observable<T>,
  selector: OperatorFunction<T, T>
) => source.pipe(selector);
